import React, { useState, useEffect } from 'react'
import Layout from './Layout';
import axios from 'axios';

function App() {

  //move to a cfg file or env var. Base URL for get company alias infra
  const aliasUrl = 'https://l1vwabn93l.execute-api.ap-southeast-2.amazonaws.com/default/getCompanyAlias';

  //state elements for managing the authentication flow  
  const [alias, setAlias] = useState('')
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [serverState, setServerState] = useState({});

  //set the intial rolling 7 days to populate the date range with a last week default.
  const sevenDaysAgo = new Date(); // Current date and time
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Subtract 7 days
  sevenDaysAgo.setHours(0, 0, 0, 0); // Set to midnight

  //store the full array of dynamortecords returned by search to render the table
  const [dynamoRecords, setDynamoRecords] = useState([])

  //store the media locatyion fo chat, sms, email or the task ID for voice, task
  const [selectedItem, setSelectedItem] = useState('')
  // WEBCHAT, VOICE< SMS, EMAIL, TASK
  const [selectedMediaType, setSelectedMediaType] = useState('')
  
  // store the actual html for email, the json chat array for SMS and webchat, just the task ID for voice/gneric tasks  
  const [mediaBody, setMediaBody] = useState('')
  const [recordLoading, setRecordLoading] = useState(false)
  const [mediaLoading, setMediaLoading] = useState(false)
  
  //These state elements are used for the search on Dynamo
  const [selectedDates, setSelectedDates] = useState([sevenDaysAgo, new Date()]);
  const [channelFilter, setChannelFilter]= useState([{value: 'EMAIL', label: 'Email'}])
  
  //State elements for dynamic search filtering - These do NOT effect the search on Dynamo - they simply filter the results
  const [emailFilter, setEmailFilter]= useState('')
  const [subjectFilter, setSubjectFilter]= useState('')
  const [phoneFilter, setPhoneFilter]= useState('')
  const [agentFilter, setAgentFilter] = useState('')
  const [queueFilter, setQueueFilter] = useState('')
  const [ filteredData, setFilteredData] = useState([])

  //Manage the authentication State based on Code URL param or Alias URL param
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    let code = searchParams.get('code');
    let base64EncodedString= searchParams.get('state');
    let aliasVar = searchParams.get('alias');
    if(aliasVar){
      window.history.replaceState({}, document.title, window.location.pathname);
      signIn(aliasVar)
    }
    if (code && base64EncodedString) {
        console.log("found code and state");
        // Step 1: Decode base64-encoded string to byte array
        const byteArray = new Uint8Array(atob(base64EncodedString).split('').map(char => char.charCodeAt(0)));
        
        // Step 2: Convert byte array to string
        const decodedString = new TextDecoder().decode(byteArray);
        
        // Step 3: Parse string back into an object
        const codeState = JSON.parse(decodedString);
        console.log('code state:', codeState)
        getCompanyData(codeState)
        setIsAuthenticated(true)
        window.history.replaceState({}, document.title, window.location.pathname);
        
    } 
  }, [setIsAuthenticated]);

  //Fetch interaction media on slected item change
  useEffect(() => {
      const fetchMedia = async () => {
        setMediaBody('')
        if(selectedMediaType === 'VOICE' || selectedMediaType === 'TASK'){
          setMediaBody(`https://${serverState.awsConnectDomain}.my.connect.aws/contact-trace-records/details/${selectedItem}?tz=Pacific/Auckland`);
          setMediaLoading(false);
        } 
        else {
        let route = ''
        if(selectedMediaType === 'WEBCHAT' || selectedMediaType === 'SMS') {
          route = 'parseChat'
        } else if (selectedMediaType === 'EMAIL') {
          route = 'parseEmail'
        }

        try {
            const response = await axios.get(`https://${serverState.apiGatewayDomain}.execute-api.${serverState.region}.amazonaws.com/prod/${route}?s3Uri=s3://${selectedItem}`, {headers: {'x-api-key': serverState.interactionsKey}});
            setMediaBody(response.data);
            console.log(response)
            setMediaLoading(false);
        } catch (err) {
            console.log(err);
            setMediaBody('')
            setMediaLoading(false);
        }
      }
    };
    if(selectedItem !==''){
      setMediaLoading(true)
      fetchMedia();
    }
  }, [selectedItem, setMediaBody, setMediaLoading])

  //Live filter the data based on mutile combined filter fields
  useEffect(() => {
    filterData();
  }, [agentFilter, queueFilter, emailFilter, phoneFilter, dynamoRecords, subjectFilter]); // Refilter data when any filter state changes

  const filterData = () => {
    let currentFilteredData = dynamoRecords;

    if (agentFilter) {
      currentFilteredData = currentFilteredData.filter(item =>
        item.Agent.toLowerCase().includes(agentFilter.toLowerCase())
      );
    }

    if (queueFilter) {
      currentFilteredData = currentFilteredData.filter(item =>
        item.Queue.toLowerCase().includes(queueFilter.toLowerCase())
      );
    }
    if (phoneFilter) {
      currentFilteredData = currentFilteredData.filter(item =>
        item.CustomerAddress.toLowerCase().includes(phoneFilter.toLowerCase()) && item.Channel === 'VOICE'
      );
    }

    if (emailFilter) {
      currentFilteredData = currentFilteredData.filter(item =>
        item.CustomerAddress.toLowerCase().includes(emailFilter.toLowerCase()) && item.Channel === 'EMAIL'
      );
    }

    if (subjectFilter) {
      currentFilteredData = currentFilteredData.filter(item =>
        item.Subject?.toLowerCase().includes(subjectFilter.toLowerCase()) && item.Channel === 'EMAIL'
      );
    }

    setFilteredData(currentFilteredData);
  };

  //Process dynamo search request using channel and dates as filters  
  const fetchDynamoRecords = async () => {
    setRecordLoading(true)
    const channelFilterString = channelFilter.map(obj => obj.value).join(', ');
    const startTime = selectedDates[0].toISOString()
    const endTime = selectedDates[1].toISOString()
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `https://${serverState.apiGatewayDomain}.execute-api.${serverState.region}.amazonaws.com/prod/scanInteractionsTable?Channel=${channelFilterString}&StartTime=${startTime}&EndTime=${endTime}`,    
      headers: { 
    
        'x-api-key': serverState.interactionsKey
    
      }
    
    };
    
     
    
    axios.request(config)
    
    .then((response) => {
      setDynamoRecords(response.data.Items);
      console.log(response)
      setRecordLoading(false);
    
    })
    
    .catch((error) => {
    
      console.log(error);
      setRecordLoading(false);
    
    });
  }
  
  //process login to Cognito - Will redirect page away to cognito hosted UI. Depends on code URL param being receioved and firing useEffect above
  const signIn = async (aliasVar) => {
    const envResult = await axios.get(`${aliasUrl}?companyAlias=${aliasVar}`);
    const envData = btoa(JSON.stringify(envResult.data));
    if(envResult.data === 'Error'){
        alert('Error with company Alias')
        console.log(envResult)
    } else {

        const ssoUrl = `${envResult.data.cognitoDomain}/oauth2/authorize?client_id=${envResult.data.appClientId}&response_type=code&scope=openid&redirect_uri=${envResult.data.interactionSearchRedirectUri}&state=${envData}&identity_provider=COGNITO`;
        window.location.href = ssoUrl;
    }
  };

  //sign user out of Cognito
  const signOut = async () => {
    const logoutUrl = `${serverState.cognitoDomain}/logout?client_id=${serverState.appClientId}&logout_uri=${window.location}&redirect_uri=${window.location}&response_type=code`;
    window.location.href = logoutUrl;
  };

  //use the connectionDetails lambda/API gateway URL rteturned into server state by getCompanyAlias request.
  // fetch additional AWS account specifics such as database names and API gateway routes. 
  //Merge results into server state variuable. This is performed AFTER authentication and therefore this data will persist in application state until logout or page refresh.
  const getCompanyData = async (codeState) => {
      console.log("fetching company data")
      const companyResult = await axios.get(codeState.connectionUrl);
      const companyData = companyResult.data;
      let mergedData = {...codeState, ...companyData}
      console.log ('company data:', companyData)
      setServerState(mergedData)
  }
  

  return (
    
      <Layout 
        filteredData={filteredData}
        agentFilter={agentFilter}
        setAgentFilter={setAgentFilter}
        queueFilter={queueFilter}
        setQueueFilter={setQueueFilter}
        phoneFilter={phoneFilter}
        setPhoneFilter={setPhoneFilter}
        subjectFilter={subjectFilter}
        setSubjectFilter={setSubjectFilter}
        emailFilter={emailFilter}
        setEmailFilter={setEmailFilter}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        selectedMediaType={selectedMediaType}
        setSelectedMediaType={setSelectedMediaType}
        mediaBody={mediaBody}
        recordLoading={recordLoading}
        mediaLoading={mediaLoading}
        setMediaLoading={setMediaLoading}
        channelFilter={channelFilter}
        setChannelFilter={setChannelFilter}
        fetchDynamoRecords={fetchDynamoRecords}
        selectedDates={selectedDates}
        setSelectedDates={setSelectedDates}
        signOut={signOut}
        signIn={signIn}
        isAuthenticated={isAuthenticated}
        alias={alias}
        setAlias={setAlias}
      />
  )
}

export default App;
